import { render, staticRenderFns } from "./CreateForumThread.vue?vue&type=template&id=7877ffe2&"
import script from "./CreateForumThread.vue?vue&type=script&lang=js&"
export * from "./CreateForumThread.vue?vue&type=script&lang=js&"
import style0 from "./CreateForumThread.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports